import { CollapseSearch, Row, Span } from 'components'
import { ICollpaseObj } from 'components/Collapse/CollapseSearch'
import { ResGetAllContracts } from 'services/Supplier/LogicalEffective'
import { COLORS, FORMAT, SPACING } from 'utils'

import { changeTabProps } from '../../../LogicalEffectiveRegister'
import { CollapseContent } from '../CollapseContent/CollapseContent'

interface CollapseProps {
  collapses: ResGetAllContracts[]
  activeContract: string
  handleChangeTab: (props: changeTabProps) => void
  pesquisaGeral: string
}

export const Collapse = ({
  activeContract,
  collapses,
  handleChangeTab,
  pesquisaGeral
}: CollapseProps) => {
  return (
    <>
      {collapses[0] ? (
        collapses.map((collapse, index) => {
          const collapseData: ICollpaseObj = {
            code: collapse.cdContrato,
            dataFim: FORMAT.formatDDMMYYYY(collapse.dtFimVigencia),
            dataIni: FORMAT.formatDDMMYYYY(collapse.dtInicioVigencia),
            dataUpdate: FORMAT.formatDDMMYYYY(collapse.dtValidacao),
            empresa: collapse.nmFornecedor,
            qtdDias: collapse.qtdDiasUltimaAnalise,
            titleCollapse: collapse.objetoContrato
          }
          return (
            <CollapseSearch
              data={collapseData}
              key={`${collapse.idContrato}-${index}-collapse`}
              hideButton
              isExpanded={collapseData.code === activeContract}
            >
              <CollapseContent
                contractData={collapse}
                handleChangeTab={handleChangeTab}
                pesquisaGeral={pesquisaGeral}
              />
            </CollapseSearch>
          )
        })
      ) : (
        <Row
          alignItems="center"
          justifyContent="center"
          marginBottom={SPACING.spacing30}
          marginTop={SPACING.spacing50}
        >
          <Span
            text="Não há contratos vinculados para este contraparte."
            fontSize="1rem"
            fontWeight="bold"
            color={COLORS.info}
          />
        </Row>
      )}
    </>
  )
}
